import React from "react";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>Hello to Codeforces API</h1>
    </div>
  );
}
